import Promise from 'bluebird';
import _ from 'underscore';
import $ from 'jquery';
import { stringifySync } from '@bingads-webui/safe-json';

// scenario is used to differentiate API calls source
const autoCompleteEndpoint = '{odataPath}Mca/V1/Customers({customer_id})/Accounts({account_id})/Default.GetAdAutoComplete?scenario={scenario}';
const adRecommendationEndpoint = '{odataPath}Campaign/V2/Customers({customer_id})/Accounts({account_id})/Campaigns({campaign_id})/Default.CreateResponsiveSearchAdRecommendation?scenario={scenario}';
const extractBusinessInfoEndpoint = '{odataPath}Campaign/V2/Customers({customer_id})/Accounts({account_id})/Campaigns({campaign_id})/Default.GetExtractedBusinessInfo?scenario={scenario}';

const formatUrl = (url, pageContext, campaignId, adGroupId, scenario) => url
  .replace('{odataPath}', pageContext.BingAdsWebApiUri)
  .replace('{account_id}', _.result(pageContext.CurrentAccount, 'Id'))
  .replace('{customer_id}', _.result(pageContext.CurrentCustomer, 'Id'))
  .replace('{campaign_id}', campaignId)
  .replace('{adgroup_id}', adGroupId)
  .replace('{scenario}', scenario);

export class AdStrengthSuggestionRepository {
  constructor({
    field,
    assetType,
    viewModel,
    pageContext,
    scenario,
  }) {
    this.field = field;
    this.assetType = assetType;
    this.viewModel = viewModel;
    this.pageContext = pageContext;
    this.scenario = scenario;
  }

  fetchAdStrengthSuggestion(isAutoComplete) {
    const {
      field,
      assetType,
      viewModel,
      pageContext,
      scenario,
    } = this;

    let currentFinalUrl = null;
    if (!_.isEmpty(viewModel.model.get('FinalUrls'))) {
      currentFinalUrl = _.first(viewModel.model.get('FinalUrls'));
    } else {
      return Promise.resolve({ data: [] });
    }

    const requestBody = isAutoComplete ? {
      url: currentFinalUrl,
      adType: 'EXTA',
      maxCount: 3,
      autoCompleteFieldIndex: assetType === 'headline' ? 0 : 2,
      adFields: [
        assetType === 'headline' ? viewModel.model.get(field) : '',
        '',
        assetType === 'headline' ? '' : viewModel.model.get(field),
      ],
    } : {
      count: 1,
      business: {
        Website: currentFinalUrl,
      },
      headlineCount: viewModel.maxHeadlineSuggestions,
      descriptionCount: viewModel.maxDescriptionSuggestions,
      caller: 'cmmt_ra',
    };

    const option = {
      url: formatUrl(
        isAutoComplete ? autoCompleteEndpoint : adRecommendationEndpoint,
        pageContext,
        viewModel.campaignId,
        viewModel.adGroupId,
        scenario
      ),
      contentType: 'application/json',
      headers: {
        authorization: `CCMTSmallToken ${pageContext.Token}`,
      },
      type: 'POST',
      data: stringifySync(requestBody),
    };

    const fetchDataPromise = new Promise((resolve) => {
      $.ajax(option).then((rawData) => {
        let data = [];
        if (!_.isEmpty(rawData)) {
          if (isAutoComplete) {
            data = _.map(rawData.Suggestions, (suggestion) => {
              suggestion.AssetType = assetType; // eslint-disable-line no-param-reassign
              return suggestion;
            });
          } else if (rawData.value && rawData.value.length > 0) {
            data = data.concat(_.map(_.first(rawData.value).Headlines, (headline) => {
              headline.Asset.AssetType = 'headline'; // eslint-disable-line no-param-reassign
              return headline.Asset;
            }));
            data = data.concat(_.map(_.first(rawData.value).Descriptions, (description) => {
              description.Asset.AssetType = 'description'; // eslint-disable-line no-param-reassign
              return description.Asset;
            }));
          }
        }
        resolve(data);
      }).catch((err) => {
        if (err && err.responseJSON && err.responseJSON[0] && err.responseJSON[0].Code === 'LanguageMismatchUserAd') {
          // ignore this error
          return;
        }
        throw err;
      });
    });

    return fetchDataPromise.then(rawData => ({
      data: rawData,
    }));
  }

  fetchBusinessInfo(isAutoComplete) {
    const {
      viewModel,
      pageContext,
      scenario,
    } = this;

    const field = 'BusinessName';

    let currentFinalUrl = null;
    if (!_.isEmpty(viewModel.model.get('FinalUrls'))) {
      currentFinalUrl = _.first(viewModel.model.get('FinalUrls'));
    } else {
      return Promise.resolve({ data: [] });
    }

    if (isAutoComplete) {
      return Promise.resolve({ data: [] });
    }

    const requestBody = {
      url: currentFinalUrl,
    };

    const option = {
      url: formatUrl(
        extractBusinessInfoEndpoint,
        pageContext,
        viewModel.campaignId,
        viewModel.adGroupId,
        scenario
      ),
      contentType: 'application/json',
      headers: {
        authorization: `CCMTSmallToken ${pageContext.Token}`,
      },
      type: 'POST',
      data: stringifySync(requestBody),
    };

    const fetchDataPromise = new Promise((resolve, reject) => {
      $.ajax(option).then((rawData) => {
        let data = [];
        if (!_.isEmpty(rawData)) {
          data = [{
            Text: rawData[field],
            AssetType: 'business',
          }];
        }
        resolve(data);
      }, reject);
    });

    return fetchDataPromise.then(rawData => ({
      data: rawData,
    }));
  }
}
